<script setup>
import { onMounted, ref } from 'vue';

const showConsentBanner = ref(false);

function checkCookieConsent() {
    const consent = localStorage.getItem('google_consent');
    if (!consent) {
        showConsentBanner.value = true;
    } else {
        setConsent(consent);
    }
}

function saveConsentSelection(consent) {
    localStorage.setItem('google_consent', consent);
    setConsent(consent);
    showConsentBanner.value = false;
}

function setConsent(consent) {
    window.gtag('consent', 'update', {
        'analytics_storage': consent
    });
}

onMounted(() => {
    checkCookieConsent();
})
</script>

<template>
    <div v-if="showConsentBanner" id="cookie-consent-banner">
        <div class="flex flex-col md:flex-row justify-between gap-4">
            <div>
                <h4 class="clarity-h4-blue">USAGE OF COOKIES</h4>
                <p>Like many other websites, the clarity website uses cookies to provide you the best browsing experience. View our Cookies Policy <a href="/privacy-policy">here</a>.</p>
            </div>
            <div class="flex flex-col gap-4">
                <button class="clarity-button-grey" @click="saveConsentSelection('granted')">Accept Additional Cookies</button>
                <button class="clarity-button-grey"  @click="saveConsentSelection('denied')">Essential Cookies Only</button>
            </div> 
        </div>
    </div>
</template>

<style lang="css" scoped>
    #cookie-consent-banner {
        position: fixed;
        left: 0px;
        bottom: 20px;
        padding: 30px;
        max-width: 700px;
        background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
        border: 1px solid var(--clarity-light-grey);
        box-shadow: 0px 0px 5px #0000001A;
        border-radius: 0px 19px 19px 0px;
        opacity: 1;
        z-index: 5000;
    }
    #cookie-consent-banner p {
        font: normal normal normal 16px/24px Open Sans;
    }
    #cookie-consent-banner button {
        width: 252px;
        height: 42px;
    }
    @media only screen and (max-width: 1024px) {
        #cookie-consent-banner {
            max-width: 650px;
        } 
    }
    @media only screen and (max-width: 500px) {
        #cookie-consent-banner {
            padding: 10px;
            max-width: 300px;
        } 
    }
</style>